import { Grid } from '@mui/material'
import { useState } from 'react'
import {
  CommonFieldProps,
  FormikSelect,
  FormikTextField,
  SelectOption
} from '../../../../../components'
import { MaybeEmail } from '../../../../../utils'
import {
  OwnInfoDeleteButtonWrapper,
  OwnInfoDeleteButtonWrapperProps
} from './own-info-delete-button-wrapper'

/**
 * Group by (group and sort) email type (tyyppi) and email priority (ensisijainen).
 * @param typeA email object
 * @param typeB email object
 * @returns compare numeric value
 */
export const groupByType = (typeA: MaybeEmail, typeB: MaybeEmail) => {
  const typeAstring: string = typeA?.tyyppi ?? ''
  const typeBstring: string = typeB?.tyyppi ?? ''

  if (typeAstring === typeBstring) {
    // There should be only one ensisijainen!
    return typeA?.ensisijainen ? -1 : 1
  } else {
    return typeAstring.localeCompare(typeBstring)
  }
}

export interface OwnInfoContactProps
  extends CommonFieldProps,
    Pick<OwnInfoDeleteButtonWrapperProps, 'arrayHelpers'> {
  contactLabelTranslationId: string
  contactTypePostfix: string
  contactTypeOptions: SelectOption[]
  contactValuePostfix: string
}

/**
 * Generic contact value & type component
 *
 * @param props type & value and translation stuff
 * @returns Input with Select
 */
export const OwnInfoContact = ({
  arrayHelpers,
  executeOnChangeFn,
  name,
  contactLabelTranslationId,
  contactTypePostfix,
  contactTypeOptions,
  contactValuePostfix
}: OwnInfoContactProps) => {
  const [isDisabled, setDisabled] = useState(false)

  const commonSelectProps = {
    disabled: isDisabled,
    executeOnChangeFn
  }

  return (
    <Grid container spacing={4} marginBottom="30px">
      <OwnInfoDeleteButtonWrapper
        arrayHelpers={arrayHelpers}
        isDisabled={isDisabled}
        name={name}
        setDisabled={setDisabled}
      >
        <FormikSelect
          {...commonSelectProps}
          name={`${name}.tyyppi`}
          options={contactTypeOptions}
          labelTranslationId={contactLabelTranslationId + contactTypePostfix}
        />
        <FormikTextField
          {...commonSelectProps}
          id={`${name}${contactValuePostfix}`}
          name={`${name}${contactValuePostfix}`}
          labelTranslationId={`${contactLabelTranslationId}.label`}
          required
        />
      </OwnInfoDeleteButtonWrapper>
    </Grid>
  )
}
